<template>
  <ul class="pa-list" v-show="visible">
    <transition-group name="fade">
      <li
        v-for="(prediction, index) in predictions"
        :key="index"
        class="pa-list__item"
        @click="$emit('click', prediction)"
      >
        {{ prediction.title }}
      </li>
    </transition-group>
  </ul>
</template>

<script>
export default {
  props: {
    predictions: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .pa-list {
    @include reset-list;
    padding-top: .5em;

    @include font($akrobat-font, 900);
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: .4em;
    line-height: 2;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    @include media-up(xl) {
      font-size: 18px;
    }

    &__item {
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceAutocomplete/PlaceAutocompleteList.vue